'use strict';

/*@ngInject*/
module.exports = function ($rootScope, $uibModal, accessibilityService, publicUsersService, clipboard) {
	return {
		scope: {
			articleId: '@'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function controller() {
			var vm = this;
			vm.userNotLoggedIn = !$rootScope.currentUser;
			vm.copyToClipboardSupported = true;
			vm.imageModalOpen = false;

			vm.$onInit = function () {
				vm.copyToClipboardSupported = clipboard.supported;

				accessibilityService.getArticleDataById(vm.articleId).then(function (response) {
					vm.articleData = response.data;

					vm.getArticleFileNames(vm.articleData.image_files);
				});
			};

			vm.getArticleFileNames = function (imageFiles) {
				angular.forEach(imageFiles, function (imageFile) {
					imageFile.fileName = imageFile.name ? _.find(imageFile.name, { language: 'est' }).value : '';
				});
			};

			vm.openImage = function () {
				$('.slick-current').find('a')[0].click();
			};

			vm.openImage = function (imageFile) {
				vm.imageId = imageFile.id;
				vm.imageName = imageFile.fileName;
				vm.imageReferenceId = vm.articleData.id;
				vm.imageModalOpen = true;
			};
		},

		template: require('./article-details.html')
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/accesssibility/view/article-details.directive.js
 **/